import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./slices/auth";
import configReducer from "./slices/config";
import userReducer from "./slices/users";
import remoteConfigReducer from "./slices/remote-config";
import postsReducer from "./slices/posts";
import programmesReducer from "./slices/programmes";
import applicationsReducer from "./slices/applications";
import calendarReducer from "./slices/calendar";
import dashboardReducer from "./slices/dashboard";
import templatesReducer from "./slices/templates";
import referralsReducer from "./slices/referrals";
import referralCodesReducer from "./slices/referralCodes";
import payoutsReducer from "./slices/payouts";
import advisorReducer from "./slices/advisor";
import aiUsageReducer from "./slices/aiUsage";
import aiCompletenessReducer from "./slices/aiCompleteness";
import aiConfigReducer from "./slices/aiConfig";
import aiConversationsReducer from "./slices/aiConversations";
import reviewReducer from "./slices/review";
import crawlerReducer from "./slices/crawler";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    config: configReducer,
    remoteConfig: remoteConfigReducer,
    posts: postsReducer,
    programmes: programmesReducer,
    applications: applicationsReducer,
    calendar: calendarReducer,
    dashboard: dashboardReducer,
    templates: templatesReducer,
    referrals: referralsReducer,
    referralCodes: referralCodesReducer,
    payouts: payoutsReducer,
    advisor: advisorReducer,
    aiUsage: aiUsageReducer,
    aiCompleteness: aiCompletenessReducer,
    aiConfig: aiConfigReducer,
    aiConversations: aiConversationsReducer,
    review: reviewReducer,
    crawler: crawlerReducer,
  },
});
